// extracted by mini-css-extract-plugin
module.exports = {"arrow-container":"styles__arrow-container___8ZTlx","arrow":"styles__arrow___BTvGM","icon":"styles__icon___2SzqW"};